import { repository, garURL } from "@/api/base"

export default {
  async findRefIdBySearchString(searchString) {
    const { data } = await repository.get(garURL + `/address/findRefIdBySearchString?searchString=${searchString}`)
    return data
  },

  async findHousesByObjectId(objectId, isMunHierarchy = true) {
    const { data } = await repository.get(garURL + `/address/findHousesByObjectId?isMunHierarchy=${isMunHierarchy}&objectId=${objectId}`)
    return data
  },

  async findFullAddressByRefId(refId, isMunHierarchy = true) {
    const { data } = await repository.get(garURL + `/address/findFullAddressByRefId?isMunHierarchy=${isMunHierarchy}&refId=${refId}`)
    return data
  },
}
